import { createActionFactory } from '../../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Email Integrations => ');

// ######################################################################################## //
// TEMPLATE DESIGNER ACTIONS
// ######################################################################################## //

const openEmailTemplateDesigner = createAction('open email template designer', (emailTemplate) => ({ emailTemplate }));
//it tries to close the email template designer, and if there are any changes that have take place in the designer, the
//close action is delayed and a message is display requesting user confirmation to either proceed with closing the
//designer or continue editing and save changes
const tryCloseEmailTemplateDesigner = createAction('try to close email template designer');
//unlike the previous action , this will close the email template designer without checking if it requires user
//confirmation to proceed
const closeEmailTemplateDesigner = createAction('closing email template designer window');

const updateEmailTemplateField = createAction('update designers email template', (emailTemplate) => ({
  emailTemplate,
}));
const updateEmailTemplate = createAction('update DB instance of an email template', (emailTemplate) => ({
  emailTemplate,
}));
const updateEmailTemplateSuccess = createAction('email template has been updated with success', (emailTemplate) => ({
  emailTemplate,
}));
const updateEmailTemplateFail = createApiFailureAction('failed to update email template');

const changeDesignerTab = createAction('change tab index for designer', (activeTab) => ({ activeTab }));
const hideDesignerMessage = createAction('hide warning message in email template designer');
const setPreviewEmail = createAction('update form preview email', (emailTo) => ({ emailTo }));

const checkEmailTemplateTokens = createAction(
  'try to check if the tokens used in the designer are valid',
  (emailTemplate) => ({ emailTemplate })
);
const checkEmailTemplateTokensSuccess = createAction('setup the the list of tokens', (response) => ({
  unknown:  response.unknown,
  known:    response.known,
  required: response.required,
}));
const checkEmailTemplateTokensFail = createApiFailureAction('failed to check email template tokens');

const fetchCampaignTokenList = createAction('request the list of available tokens');
const setCampaignTokenList = createAction('set the list of available tokens', (tokenList) => ({ tokenList }));
const getCampaignTokenListFail = createApiFailureAction('failed to get the list of token for current campaign');

const sendPreviewEmailTemplate = createAction(
  'sends a test emailTemplate to email destination',
  (emailTo, emailTemplate) => ({ emailTo, emailTemplate })
);
const sendingPreviewEmailTemplate = createAction(
  'disable the send button in the preview test column while the email is being sent'
);
const sendPreviewEmailTemplateSuccess = createAction('sending preview email was a success');
const sendPreviewEmailTemplateFail = createApiFailureAction('failed to send test email template preview');

const closeTokenMessage = createAction('close token warning label');
const closeTestEmailMessage = createAction('close test email message');

const showValidationMessage = createAction('show designer validation message', (formErrors) => ({ formErrors }));
const hideValidationMessage = createAction('hide designer validation message');

export default {
  openEmailTemplateDesigner,
  closeEmailTemplateDesigner,
  tryCloseEmailTemplateDesigner,
  updateEmailTemplateField,
  updateEmailTemplate,
  updateEmailTemplateSuccess,
  updateEmailTemplateFail,
  changeDesignerTab,
  hideDesignerMessage,
  setPreviewEmail,
  checkEmailTemplateTokens,
  checkEmailTemplateTokensSuccess,
  checkEmailTemplateTokensFail,
  getCampaignTokenListFail,
  fetchCampaignTokenList,
  setCampaignTokenList,
  sendPreviewEmailTemplate,
  sendingPreviewEmailTemplate,
  sendPreviewEmailTemplateSuccess,
  sendPreviewEmailTemplateFail,
  closeTokenMessage,
  closeTestEmailMessage,
  showValidationMessage,
  hideValidationMessage,
};
